/* Recharge selling-plan wiring.
   The design's frequency pills are rendered from product.selling_plan_groups, but the plan
   ids never reached the markup, so selecting a frequency added a one-time purchase. This
   maps the rendered pills onto the product's real plans and keeps the hidden selling_plan
   input and the add-to-cart button in sync. Loaded after theme.js.

   Two fixes over the original:

   1. Clicking the Subscribe tier used to call select(visible[0]), forcing the FIRST pill
      every time. That fought the preselected default and made the pills feel unswitchable:
      the Starter Kit lit "30 days" but submitted the 15 day id. It now keeps whatever is
      already selected, falling back to the preferred interval and only then to the first.

   2. Pills are matched to plans by id where the markup already carries one, instead of
      purely by index. buybox-tail sorts the pills shortest-first, so index order no longer
      matches the order Recharge returns them in, and a positional map could pair a label
      with someone else's plan. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function daysOf(t) {
    var m = String(t || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function init() {
    var form = $('[data-nw-product-form]');
    var dataEl = $('[data-nw-product-json]');
    if (!form || !dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var plans = [];
    (product.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (sp) { plans.push(sp); });
    });

    var planInput = $('[name="selling_plan"]', form);
    if (!planInput && plans.length) {
      planInput = document.createElement('input');
      planInput.type = 'hidden';
      planInput.name = 'selling_plan';
      form.appendChild(planInput);
    }

    var pills = $$('[data-nw-click="plan:select"]', form);

    pills.forEach(function (btn, i) {
      // prefer an id already on the button, or one whose interval matches the label
      var plan = null;
      var existing = btn.getAttribute('data-nw-plan');
      if (existing) {
        plan = plans.filter(function (p) { return String(p.id) === String(existing); })[0] || null;
      }
      if (!plan) {
        var d = daysOf(btn.textContent);
        if (d !== null) {
          plan = plans.filter(function (p) { return daysOf(p.name) === d; })[0] || null;
        }
      }
      if (!plan) plan = plans[i];

      if (plan) {
        btn.setAttribute('data-nw-plan', plan.id);
        if (!btn.textContent.trim()) btn.textContent = plan.name;
      } else {
        // no matching plan in Recharge - hide rather than silently sell one-time
        btn.hidden = true;
      }
    });

    function select(btn) {
      var id = btn ? btn.getAttribute('data-nw-plan') : '';
      if (planInput) planInput.value = id || '';
      pills.forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      $$('[data-nw-click="cart:add-product"]', form).forEach(function (b) {
        if (id) b.setAttribute('data-nw-plan', id);
        else b.removeAttribute('data-nw-plan');
      });
    }

    function visiblePills() {
      return pills.filter(function (b) { return !b.hidden; });
    }
    function currentPill() {
      return visiblePills().filter(function (b) { return b.classList.contains('is-selected'); })[0] || null;
    }
    function preferredPill() {
      var want = window.NoWaDefaultPlanDays;
      if (!want) return null;
      return visiblePills().filter(function (b) { return daysOf(b.textContent) === want; })[0] || null;
    }

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    // Choosing the Subscribe pack tier keeps the shopper's frequency if they picked one,
    // then the preferred default, and only then the first. Any other tier clears the plan
    // back to a one-time purchase.
    $$('[data-nw-click="opt:select"]', form).forEach(function (packBtn) {
      packBtn.addEventListener('click', function () {
        var visible = visiblePills();
        if (/subscribe/i.test(packBtn.textContent || '') && visible.length) {
          select(currentPill() || preferredPill() || visible[0]);
        } else {
          select(null);
        }
      });
    });

    // initial state: honour the preferred interval rather than whatever is first
    var start = currentPill() || preferredPill();
    if (start) select(start);

    window.NoWaPlans = { plans: plans, pills: pills.length };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
